import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardTitle, CardActions } from 'material-ui/Card';
import { GridList, GridTile, RaisedButton, Toggle } from 'material-ui';
import { Step, Stepper, StepButton } from 'material-ui/Stepper';
import { Field, reduxForm } from 'redux-form';
import EditIcon from 'material-ui/svg-icons/image/edit';
import ViewIcon from 'material-ui/svg-icons/image/view-comfy';
import ForwardIcon from 'material-ui/svg-icons/navigation/arrow-forward';
import BackIcon from 'material-ui/svg-icons/navigation/arrow-back';
import isObject from 'lodash.isobject';
import get from 'lodash.get';
import pick from 'lodash.pick';
import { connect } from 'react-redux';
import JSONSchemaForm from 'react-jsonschema-form';
import { showNotification } from 'admin-on-rest';
import fetcher from '../helpers/fetcher';
import { URL_AGENTS, URL_PROJECTS, URL_CUSTOMERS } from '../constants';

//TODO
// import {
//   SortableContainer,
//   SortableElement,
//   arrayMove
// } from 'react-sortable-hoc';
import { log } from '../helpers/log';
import { getTypeOf, getFieldForHeader } from '../helpers/fields';
// import { deepStrictEqual } from 'assert';

import {
  getProjectFormSchemaSteps,
  STEP_FOR_PREVIEW_FORM
} from '../helpers/project';
import { CallScreenForm } from './CallScreenForm';

class ProjectWizardForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = this._getStateFromProps(props);
    //TODO validate this
    // if (props.validate) {
    //   props.validate({
    //     handler: param => console.log('try to validate it' + param) || 'error'
    //   });
    // }
  }

  _getStateFromProps = props => ({
    currentStep: props.record.id ? 1 : 0,
    previewIsVisible: true,
    previewIsEditable: true,
    showHiddenFields: true,

    record: {
      ...pick(props.record, ['name'])
    },

    projectData: {
      description: '',
      script: '',
      callDays: 0,
      headers: '',
      csvPreview: [],
      filesUploaded: [],
      filesImported: [],
      fileHeaders: [],
      ...props.record,
      ...get(props, 'record.meta.projectData')
    },

    callScreenFormData: {
      columnsNumber: 3,
      sections: [
        {
          title: 'Project info',
          fieldsNumber: 3
        },
        {
          title: 'Personal Details',
          fieldsNumber: 3
        },
        {
          title: 'Call Data',
          fieldsNumber: 20
        }
      ],
      fields: [],
      ...get(props, 'record.meta.callScreenFormData')
    },
    dynamicData: {}
  });

  componentDidMount() {
    //loadFromPreviousList
    //TODO fix this put it in a common place, use redux
    fetcher.get(URL_AGENTS).then(res => {
      const agents = get(res, 'data.data', []);
      this.setState({
        dynamicData: {
          ...this.state.dynamicData,
          agents: {
            items: {
              type: 'string',
              enumNames: agents.map(
                agent => `${agent.firstName} ${agent.lastName} ${agent.email}`
              ),
              enum: agents.map(agent => agent.id)
            }
          }
        }
      });
    });
    fetcher.get(URL_CUSTOMERS).then(res => {
      const customers = get(res, 'data.data', []);
      this.setState({
        dynamicData: {
          ...this.state.dynamicData,
          customers: {
            items: {
              type: 'string',
              enumNames: customers.map(
                user => `${user.firstName} ${user.lastName} ${user.email}`
              ),
              enum: customers.map(agent => agent.id)
            }
          }
        }
      });
    });
    fetcher.get(URL_PROJECTS).then(res => {
      const projects = get(res, 'data.data', []);
      this.setState({
        dynamicData: {
          ...this.state.dynamicData,
          projectSource: {
            enumNames: projects.map(
              project => `${project.name} (${project.id})`
            ),
            enum: projects.map(project => project.id)
          }
        }
      });
    });
  }

  _addDynamicDataToFormSchemaStep = schemaStep => {
    if (schemaStep) {
      Object.keys(get(schemaStep, 'schema.properties', {})).map(
        propertyName => {
          if (this.state.dynamicData[propertyName]) {
            schemaStep.schema.properties[propertyName] = {
              ...schemaStep.schema.properties[propertyName],
              ...this.state.dynamicData[propertyName]
            };
          }
        }
      );
    }
    console.log('schema', schemaStep);
    return schemaStep;
  };

  _getProjectFormSchema = () => {
    const formSchemaSteps = getProjectFormSchemaSteps(this.props.record.id);
    if (formSchemaSteps && formSchemaSteps[this.state.currentStep]) {
      return this._addDynamicDataToFormSchemaStep(
        formSchemaSteps[this.state.currentStep]
      );
    }
    return {
      schema: {},
      uiSchema: {}
    };
  };

  _getProjectFormSchemaSteps = () => {
    const formSchemaSteps = getProjectFormSchemaSteps(this.props.record.id);
    if (formSchemaSteps && formSchemaSteps.length) {
      return formSchemaSteps.length;
    }
    return 0;
  };

  _getFieldDataFromHeader = (header, value) => {};

  _getFields = (headers, types = {}) => {
    return headers.map((header, index) =>
      getFieldForHeader(
        header,
        get(types, `[${header}].dataType`, 'string'),
        types[header]
      )
    );
  };

  _onProjectFormChange = data => {
    //TODO make this simpler
    console.log('onProjectFormChange', data);

    const { formData } = data;
    // const callScreenFormData = {
    //   ...get(this.props, 'record.meta.callScreenFormData')
    // };
    let callScreenFormData = { ...this.state.callScreenFormData };
    let fields = [...(callScreenFormData.fields || [])];
    // const projectData = {
    //   ...get(this.props, 'record.meta.projectData')
    // };
    const projectData = { ...this.state.projectData };

    let filesUploaded = [...(projectData.filesUploaded || [])];
    let filesImported = [...(projectData.filesImported || [])];
    if (isObject(formData.file) && formData.file.name) {
      const uploadFileResults = formData.file;
      filesUploaded.push(uploadFileResults.name);
      if (uploadFileResults.meta) {
        const newFields = this._getFields(
          uploadFileResults.meta.fields,
          uploadFileResults.meta.fieldTypes
        );
        newFields.forEach(newField => {
          if (!fields.find(field => field.identifier === newField.identifier)) {
            fields.push(newField);
          }
        });
      }
      if (uploadFileResults.imported) {
        filesImported.push(uploadFileResults.filename);
      }
    }

    if (formData.newHeaders && formData.newHeaders.newField) {
      const newField = formData.newHeaders.newField;
      const position = ~~formData.newHeaders.position;
      if (!fields.find(field => field.identifier === newField.identifier)) {
        fields.splice(position, 0, newField);
      } else {
        this.props.showNotification(
          'A field with the same name already exists. Please add a different name.',
          'warning'
        );
      }
    }

    let sections = formData.sections;

    callScreenFormData.fields = fields;
    callScreenFormData.columnsNumber = formData.columnsNumber;
    callScreenFormData.sections = sections;

    if (formData.projectSource && formData.projectSource.callScreenFormData) {
      callScreenFormData = formData.projectSource.callScreenFormData;
    }

    projectData.filesUploaded = filesUploaded;
    projectData.filesImported = filesImported;
    projectData.fileHeaders = fields.map(field => field.csvHeader);
    projectData.description = formData.description;
    projectData.script = formData.script;
    projectData.callDays = formData.callDays;
    projectData.headers = formData.headers;
    projectData.agents = formData.agents;
    projectData.customers = formData.customers;
    projectData.delimiter = formData.delimiter;
    projectData.newline = formData.newline;

    this.props.change(
      'meta',
      JSON.stringify({ callScreenFormData, projectData })
    );
    this.props.change('name', formData.name);
    this.props.change('agents', formData.agents);
    this.props.change('customers', formData.customers);
    this.props.change('callDays', formData.callDays);

    this.setState({
      callScreenFormData,
      projectData,
      record: {
        ...this.state.record,
        name: formData.name,
        callDays: formData.callDays
      }
    });
  };

  _goToStep = index => {
    this.setState({ currentStep: index });
  };

  _goToPrev = () => {
    this.setState({ currentStep: Math.max(this.state.currentStep - 1, 0) });
  };

  _goToNext = () => {
    this.setState({
      currentStep: Math.min(
        this.state.currentStep + 1,
        this._getProjectFormSchemaSteps() - 1
      ),
      previewIsVisible:
        this.state.currentStep === 2 || this.state.previewIsVisible
    });
  };

  _onCallScreenFormChange = data => {
    const { fields } = data;
    if (fields) {
      const callScreenFormData = { ...this.state.callScreenFormData };
      callScreenFormData.fields = fields;
      const projectData = { ...this.state.projectData };
      this.props.change(
        'meta',
        JSON.stringify({
          callScreenFormData,
          projectData
        })
      );
      this.setState({ callScreenFormData, projectData });
    }
  };

  _toggleEdit = () => {
    this.setState({
      previewIsEditable: !this.state.previewIsEditable,
      previewIsVisible: true
    });
  };

  _togglePreview = () => {
    this.setState({
      previewIsVisible: !this.state.previewIsVisible
    });
  };

  _toggleShowHiddenFields = () => {
    this.setState({
      showHiddenFields: !this.state.showHiddenFields
    });
  };

  render() {
    const { schema, uiSchema } = this._getProjectFormSchema();

    const callScreenFormData = this.state.callScreenFormData;
    const formData = {
      ...this.state.projectData,
      name: this.state.record.name,
      callDays: this.state.record.callDays,
      headers: (this.state.projectData || {}).headers,
      columnsNumber: this.state.callScreenFormData.columnsNumber,
      sections: this.state.callScreenFormData.sections,
      file: {
        delimiter: this.state.projectData.delimiter,
        newline: this.state.projectData.newline,
        projectId: this.props.record.id
      }
    };
    return (
      <Card>
        <Stepper linear={false} activeStep={this.state.currentStep}>
          <Step>
            <StepButton onClick={() => this._goToStep(0)}>
              Project details
            </StepButton>
          </Step>
          <Step>
            <StepButton onClick={() => this._goToStep(1)}>
              File uploads
            </StepButton>
          </Step>
          <Step>
            <StepButton onClick={() => this._goToStep(2)}>
              Import from other project
            </StepButton>
          </Step>
          <Step>
            <StepButton onClick={() => this._goToStep(3)}>
              Call screen
            </StepButton>
          </Step>
          <Step>
            <StepButton onClick={() => this._goToStep(4)}>
              Access (agents / customers)
            </StepButton>
          </Step>
        </Stepper>
        <div className="bootstrap columns-form">
          <JSONSchemaForm
            options={{ addSubmit: false }}
            schema={schema}
            uiSchema={uiSchema}
            formData={formData}
            onChange={this._onProjectFormChange}
            onSubmit={log('submitted')}
            onError={log('errors - form')}
          >
            <p>&nbsp;</p>
          </JSONSchemaForm>
        </div>

        {this.state.currentStep === STEP_FOR_PREVIEW_FORM && (
          <Card className="preview-form">
            <CardTitle title="Preview Agent' Screen" />
            <div style={{ width: 400, margin: 10 }}>
              <Toggle
                label="Visible"
                onToggle={this._togglePreview}
                toggled={this.state.previewIsVisible}
                icon={<ViewIcon />}
              />
              <Toggle
                label="Editable"
                onToggle={this._toggleEdit}
                toggled={this.state.previewIsEditable}
                icon={<EditIcon />}
              />
              <Toggle
                label="Show hidden fields"
                onToggle={this._toggleShowHiddenFields}
                toggled={this.state.showHiddenFields}
                icon={<EditIcon />}
              />
            </div>
            {this.state.previewIsVisible && (
              <CallScreenForm
                formSettings={callScreenFormData}
                editable={this.state.previewIsEditable}
                showHidden={this.state.showHiddenFields}
                onFieldChange={this._onCallScreenFormChange}
              />
            )}
          </Card>
        )}
        <CardActions>
          {this.state.currentStep > 0 && (
            <RaisedButton
              onClick={this._goToPrev}
              label="Prev"
              primary
              icon={<BackIcon />}
            />
          )}
          {this.state.currentStep < this._getProjectFormSchemaSteps() - 1 && (
            <RaisedButton
              onClick={this._goToNext}
              label="Next"
              primary
              icon={<ForwardIcon />}
            />
          )}
        </CardActions>
      </Card>
    );
  }
}
ProjectWizardForm.propTypes = {
  record: PropTypes.object,
  change: PropTypes.func,
  showNotification: PropTypes.func
};

export default reduxForm({ form: 'record-form', destroyOnUnmount: false })(
  connect(null, {
    showNotification
  })(ProjectWizardForm)
);



// WEBPACK FOOTER //
// ./src/components/ProjectWizardForm.js